import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'smart-modal',
  templateUrl: './smart-modal.component.html',
  styleUrls: ['./smart-modal.component.css']
})
export class SmartModalComponent implements OnInit {
  @Input() Id: string;
  @Input() Title: string;
  @Input() TitleClass: string;
  @Input() SizeClass: string;
  @Input() IsCentered: boolean = true;
  @Input() IsScrolled: boolean = true;
  @Input() ShowFooter: boolean = true;
  @Input() IsStatic: boolean = false;
  @Input() ZIndex: 1050;
  @Output() IsCloseButtonClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() ShowCloseButton: boolean = true;
  @Input() ModelBodyClass: string = "";
  @Input() ContainerfluidClass: string = "";
  @Input() IsShowLogo:boolean = true;
  @Input() HideHeader: boolean = false;
  @Input() IsBackdrop:boolean = false;
  CenteredClass: string;
  ScrolledClass: string;
  @Output() onClose = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit(): void {
    this.CenteredClass = this.IsCentered ? "modal-dialog-centered" : "";
    this.ScrolledClass = this.IsScrolled ? "modal-dialog-scrollable" : "";   
  }

  CloseModal(){
    this.IsCloseButtonClicked.emit(true);
    this.onClose.emit();
  }
}
